import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import mdToHtml from "../utils/mdToHtml";

import { Image } from 'components';

const MdTextMedia = ({
  enabled,
  text,
  textUk,
  textEn,
  textSe,
  image,
  reverse,
  stars,
  badges,
  badgeOne,
  badgeTwo,
  className,
  locale
}) => {
  if(!enabled) return false;

  let localText = null;
  switch(locale) {
    case 'uk':
      localText = textUk
      break;
    case 'en':
      localText = textEn
      break;
    case 'se':
      localText = textSe
      break;
    default:
      localText = null;
      break;
  }

  return (
    <div className={cx('section-wrapper md-text-media', { reverse }, [className])}>
      <div className='section-text'>
        <div dangerouslySetInnerHTML={{ __html: mdToHtml(localText) }} />
        {stars && <Image url='icons/icon_stars.png' alt='5 stars on trustpilot' className='trustpilot-placeholder' />}
        {badges && 
            <div className='section-icons'>
                <div className='icon-wrapper'>
                    <Image url='icons/icon_aligners.svg' alt='Prescribed by dentist icon' />
                    <p><b>{badgeOne}</b></p>
                </div>
                <div className='icon-wrapper'>
                    <Image url='icons/icon_whitening.svg' alt='Long lasting results icon' />
                    <p><b>{badgeTwo}</b></p>
                </div>
            </div>}
        <div dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />
      </div>
      <div className='section-media'>
        <Image url={image.url} alt={image.alt} />
      </div>
    </div>
  );
};

MdTextMedia.propTypes = {
  text: PropTypes.string,
  textUk: PropTypes.string,
  textEn: PropTypes.string,
  textSe: PropTypes.string,
  badgeOne: PropTypes.string,
  badgeTwo: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    noBlur: PropTypes.bool,
  }).isRequired,
  reverse: PropTypes.bool.isRequired,
  stars: PropTypes.bool,
  badges: PropTypes.bool,
  className: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

MdTextMedia.defaultProps = {
  reverse: false,
  stars: true,
  badges: false,
  className: '',
};

export default MdTextMedia;
